module.exports = __webpack_public_path__ + "./images/block_marker.e83fd8.svg";